import { useEffect } from 'react'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { UseQueryResult } from '@tanstack/react-query'
import { usePortalQuery } from 'src/Libs/api'
import { fetchHagerUserAccountId } from '../api/hager-user-account-id.api'

export const hagerUserAccountIdQueryKey = (username: string | undefined) => ['hager-user-account-id', username] as const

/**
 * `installation.ownerAccountId` is uuid for hager users,
 * which is why we need to fetch from the 'users' api,
 * to get the integer account id value.
 */
export const useHagerUserAccountId = (username: string | undefined, enabled = true): UseQueryResult<number | null, Error> => {
  const authFetch = useAuthFetchWithResponse()
  const { enqueueErrorStack } = useSnackbar()
  const { t } = useCustomTranslation()

  const query = usePortalQuery({
    queryKey: hagerUserAccountIdQueryKey(username),
    queryFn: () => fetchHagerUserAccountId(username, authFetch),
    enabled: enabled && !!username,
  })

  useEffect(() => {
    if (enabled && query.error) {
      console.error('Error fetching the Hager user account ID', query.error)
      enqueueErrorStack(t('errors.usersNotAvailable'))
    }
  }, [enabled, query.error, enqueueErrorStack, t])

  return query
}
